import React, { useState, useEffect, useMemo, useRef, Fragment } from 'react'
import styles from './styles'
import { useSelector, useDispatch } from 'react-redux'
import usePrevious from '../../utils/previousHook'
import { removeStreamLocal } from 'actions/event'
import Webrtc from './webrtc'
import moment from 'moment'
import VideoControls from './VideoControls'
import EngagementButtons from 'components/EngagementButtons'
import { Box } from '@material-ui/core'
import {
  setVideoControlled,
  setAudioSetting,
  getServerTime,
  setServerTime
} from 'actions/stream'
import ViewerCount from 'components/ViewerCount'
import classnames from 'clsx'
import { useFullScreen } from 'react-browser-hooks'
import { withStyles } from '@material-ui/core/styles'
import VideoButtons from 'components/VideoButtons'
import { isEmpty } from 'lodash'
import { useMediaControls } from 'react-browser-hooks'
import Captions from './Captions'
import stream from 'reducers/stream'

const initalVideoSrcMp4 = 'https://assets.bidr.co/media/blank.mp4'
const initalVideoSrcMov = 'https://assets.bidr.co/media/blank.mov'

const LiveVideo = ({
  setEventDetailsOpen,
  eventDetailsOpen,
  welcomeDialogOpen,
  onPlayButtonClick,
  handleFullscreen,
  handleAudio,
  classes
}) => {
  //
  const cloudinaryRef = useRef(null)
  const egliveRef = useRef(null)
  const mutedResult = useSelector(state => state.stream.audioSetting)
  const stream = useSelector(state => state.stream)
  const orientation = useSelector(state => state.window.orientation)
  const windowFullscreen = useSelector(state => state.window.fullscreen)
  const { fullScreen } = useFullScreen()
  const dispatch = useDispatch()
  const [alreadyPlaying, setAlreadyPlaying] = useState(null)
  const [bufferCounter, setBufferCounter] = useState(0)

  const videoControlled = useSelector(
    state =>
      state.stream.cloudinaryVideoControlled &&
      state.stream.egLiveVideoControlled
  )

  const displayVideo = useSelector(state => state.stream.displayVideo)
  const previousDisplayVideo = usePrevious(displayVideo)

  const previousVideoControlled = usePrevious(videoControlled)
  const event = useSelector(state => state.event.event)
  // change to actual value later event.mode?
  const donateMode = Number(event.live_settings.live_mode) === 1
  const currentItem = useSelector(state => {
    if (state.items.liveItem && !donateMode) {
      return state.items.liveItem
    } else {
      return null
    }
  })
  const hasLiveVideo =
    event.live_url_data && event.live_url_data.find(x => x.live_now)
  const liveVideo =
    // videoControlled here is for weird mobile issue
    videoControlled && hasLiveVideo
  const streamId = liveVideo && liveVideo.id
  const previousVideo = usePrevious(liveVideo)
  const isAlreadyBroadcasting = useSelector(state => state.stream.name)
  const prevIsAlreadyBroadcasting = usePrevious(isAlreadyBroadcasting)
  const [streamClass, setStreamClass] = useState(null)
  // console.log(liveVideo, event)
  const egliveVideo = document.getElementById('egliveVideo')
  const cloudinaryVideo = document.getElementById('cloudinaryVideo')
  const resetVideos = mutedResult => {
    if (streamClass) {
      streamClass.kill()
      setStreamClass(null)
    }
    if (window.location.href.includes('&videomute=1')) {
      try {
        if (liveVideo.type === 'zoom') {
          dispatch(setAudioSetting(true))
          document.getElementById('egliveVideo').muted = true
          document.getElementById('cloudinaryVideo').muted = true
        } else {
          dispatch(setAudioSetting(false))
          document.getElementById('egliveVideo').muted = false
          document.getElementById('cloudinaryVideo').muted = false
        }
      } catch (err) {
        egliveVideo.pause()
        egliveVideo.removeAttribute('src')
        egliveVideo.load()
        egliveVideo.mute = { mutedResult }
        cloudinaryVideo.pause()
        cloudinaryVideo.removeAttribute('src')
        cloudinaryVideo.load()
        cloudinaryVideo.mute = { mutedResult }
      }
    } else {
      egliveVideo.pause()
      egliveVideo.removeAttribute('src')
      egliveVideo.load()
      egliveVideo.mute = { mutedResult }
      cloudinaryVideo.pause()
      cloudinaryVideo.removeAttribute('src')
      cloudinaryVideo.load()
      cloudinaryVideo.mute = { mutedResult }
    }
  }

  // for stream and video
  const playVideo = mutedResult => {
    console.log('playVideo called with:', { mutedResult, liveVideo })
    
    if (!isAlreadyBroadcasting) {
      setEventDetailsOpen(false)
      resetVideos(mutedResult)
      
      if (!liveVideo) {
        console.error('playVideo called but liveVideo is null or undefined')
        return
      }
      
      if (liveVideo.type === 'cloudinary') {
        console.log('Setting up cloudinary video with URL:', liveVideo.optimized_url || liveVideo.url)
        //add diff of server and local to offsetInSeconds

        let offsetInSeconds = moment().diff(liveVideo.start_time, 'seconds')
        cloudinaryVideo.src = liveVideo.optimized_url || liveVideo.url
        
        console.log('Attempting to play cloudinary video')
        // Add a try-catch around the play() method to be more resilient
        try {
          // Make sure video is loaded and ready before trying to play
          cloudinaryVideo.load();
          
          // Set an event handler for when the video is loaded
          cloudinaryVideo.onloadedmetadata = () => {
            console.log('Video metadata loaded, now attempting to play');
            
            cloudinaryVideo
              .play()
              .then(async () => {
                console.log('Cloudinary video play successful')
                if (!event.live_settings.replay_mode) {
                  console.log('Getting server time for stream ID:', streamId)
                  let videoTime = await dispatch(getServerTime(streamId))
                    .then(data => {
                      console.log('Server time received:', data)
                      // const videoMoment = moment(liveVideo.start_time).unix()
                      // const serverMoment = moment(data).unix()
                      return data
                    })
                    .catch(err => {
                      console.error('Error getting server time:', err)
                      return null
                    });
                    
                  if (
                    videoTime === null ||
                    videoTime === undefined ||
                    videoTime < 0
                  ) {
                    console.log('Using offset seconds as fallback video time:', offsetInSeconds)
                    videoTime = offsetInSeconds
                  }
                  
                  console.log('Setting video currentTime to:', Math.abs(videoTime))
                  cloudinaryVideo.currentTime = Math.abs(videoTime)
                }
              })
              .catch(err => {
                console.error('Error playing cloudinary video:', err)
              });
          };
        } catch (err) {
          console.error('Exception playing cloudinary video:', err)
        }
      } else {
        console.log('Setting up WebRTC with URL:', liveVideo.url)
        try {
          window.webRTC = new Webrtc(liveVideo.url, 'egliveVideo', err => {
            console.error('WebRTC stream error:', err)
            dispatch(removeStreamLocal(liveVideo.id))
            if (!currentItem && !donateMode) {
              console.log('No current item or donate mode, showing event details')
              setEventDetailsOpen(true)
            }
          })
          console.log('WebRTC initialized successfully')
          setStreamClass(window.webRTC)
        } catch (err) {
          console.error('Error initializing WebRTC:', err)
        }
      }
      if (!alreadyPlaying) {
        setAlreadyPlaying(true)
      }
    }
  }

  // react to displayVideo changing
  useEffect(() => {
    if (previousDisplayVideo === true && displayVideo === false) {
      // stop video
      resetVideos()
    }
    if (previousDisplayVideo === false && displayVideo === true) {
      if (liveVideo) {
        playVideo()
      }
    }
  }, [displayVideo])

  // watch for changes on videoControlled
  useEffect(() => {
    if (previousVideoControlled === true && videoControlled === false) {
      // videos just became uncontrolled
      resetVideos()
    } else if (previousVideoControlled === false && videoControlled === true) {
      // Videos just became controlled, force play if we have a video
      console.log('Video became controlled, checking for videos to play')
      if (liveVideo && displayVideo) {
        console.log('Found live video when controls became active, playing now')
        // Force a small delay to ensure DOM is ready
        setTimeout(() => {
          playVideo({ mutedResult })
        }, 100)
      }
    }
  }, [videoControlled])

  // watch for changes to what video/stream to show
  useEffect(() => {
    console.log('LiveVideo useEffect for liveVideo/videoControlled:', { 
      liveVideo, 
      videoControlled, 
      isAlreadyBroadcasting,
      displayVideo,
      hasLiveVideo,
      event
    })
    
    if (!isAlreadyBroadcasting) {
      if (videoControlled) {
        if (liveVideo && liveVideo.url) {
          console.log('Video ready to play:', liveVideo)
          const oldUrl = previousVideo && previousVideo.url
          const newUrl = liveVideo.url
          const oldLive = previousVideo && previousVideo.live_now
          const newLive = liveVideo.live_now
          if (oldUrl !== newUrl || oldLive !== newLive || !alreadyPlaying) {
            if (displayVideo) {
              console.log('Calling playVideo with:', { mutedResult })
              playVideo({ mutedResult })
            } else {
              console.log('Not playing video - displayVideo is false')
            }
          } else {
            console.log('Not playing video - no change in URL or live status')
          }
        } else {
          console.log('No valid liveVideo or URL - resetting videos')
          resetVideos({ mutedResult })
        }
      } else {
        console.log('Not videoControlled yet')
      }
    } else {
      console.log('User is already broadcasting - not playing video')
    }
  }, [liveVideo, videoControlled])

  // to gain inital player access
  useEffect(() => {
    if (egliveVideo && cloudinaryVideo && window.isIos) {
      egliveVideo.src = `${initalVideoSrcMov}?v=${Math.random()}`
      egliveVideo.load()
      cloudinaryVideo.src = `${initalVideoSrcMov}?v=${Math.random()}`
      cloudinaryVideo.load()
    } else if (egliveVideo && cloudinaryVideo) {
      egliveVideo.src = `${initalVideoSrcMp4}?v=${Math.random()}`
      egliveVideo.load()
      cloudinaryVideo.src = `${initalVideoSrcMp4}?v=${Math.random()}`
      cloudinaryVideo.load()
    }
  }, [egliveVideo, cloudinaryVideo])

  // reset video if this user is publishing to not get echo
  useEffect(() => {
    if (isAlreadyBroadcasting && !prevIsAlreadyBroadcasting) {
      resetVideos()
    }
  }, [isAlreadyBroadcasting])

  // make sure video is unmuted
  if (videoControlled) {
    if (egliveVideo && egliveVideo.muted) {
      egliveVideo.muted = { mutedResult }
    }
    if (cloudinaryVideo && cloudinaryVideo.muted) {
      cloudinaryVideo.muted = { mutedResult }
    }
  }

  useEffect(() => {
    if (!welcomeDialogOpen) {
      // controll when to show video and not
      if ((currentItem && currentItem.item_id) || donateMode || liveVideo) {
        setEventDetailsOpen(false)
      } else {
        setEventDetailsOpen(true)
      }
    }
  }, [liveVideo, currentItem, donateMode, welcomeDialogOpen])

  // // check if fullscreen mode is available
  // if (
  //   document.fullscreenEnabled ||
  //   document.webkitFullscreenEnabled ||
  //   document.mozFullScreenEnabled ||
  //   document.msFullscreenEnabled
  // ) {
  //   // which element will be fullscreen
  //   var video = document.getElementById('#video-box')
  //   // Do fullscreen
  //   if (video.requestFullscreen) {
  //     video.requestFullscreen()
  //   } else if (video.webkitRequestFullscreen) {
  //     video.webkitRequestFullscreen()
  //   } else if (video.mozRequestFullScreen) {
  //     video.mozRequestFullScreen()
  //   } else if (video.msRequestFullscreen) {
  //     video.msRequestFullscreen()
  //   }
  // } else {
  //   document.querySelector('.error').innerHTML =
  //     'Your browser is not supported'
  // }

  const backgroundImage = useMemo(() => {
    if (!isEmpty(currentItem)) {
      // an item is active
      if (!isEmpty(currentItem.image)) {
        // active item has an image to display
        return `url(${currentItem.image[0].fullSizeUrl})`
      }
    }
    // default to returning event_logo
    return 'none'
  }, [event, currentItem, liveVideo, displayVideo])
  // console.log('render')
  return (
    <div
      className={classnames(classes.videoContainer, classes[orientation], {
        [classes.videoControlled]: videoControlled,
        [classes.isFullscreen]: fullScreen || windowFullscreen
      })}
    >
      {videoControlled && <ViewerCount />}
      {videoControlled && (
        <VideoButtons
          handleFullscreen={handleFullscreen}
          handleAudio={handleAudio}
          cloudinaryRef={cloudinaryRef}
          egliveRef={egliveRef}
          streamId={streamId}
        />
      )}
      {!isAlreadyBroadcasting && (
        <Fragment>
          <Box
            className={classnames(classes.eventImage, classes.itemImage, {
              [classes.itemImageVisible]:
                (!liveVideo || !displayVideo) &&
                videoControlled &&
                backgroundImage !== 'none'
            })}
            style={{ backgroundImage: backgroundImage, zIndex: 2 }}
          />
          <Box
            className={classnames(classes.eventImage, {
              [classes.eventImageVisible]: !liveVideo || !displayVideo
            })}
            style={{ backgroundImage: `url(${event.event_logo})` }}
          />
          {!liveVideo && (
            <Fragment>
              <VideoControls
                event={event}
                hasLiveVideo={hasLiveVideo}
                videoControlled={videoControlled}
                onPlayButtonClick={onPlayButtonClick}
              />
            </Fragment>
          )}
          <Box className={classes.engagementBox}>
            <Captions />
            {videoControlled && <EngagementButtons />}
          </Box>
          <div className={classes.videoCover} />
          {/* THIS VIDEO ELEMENT IS VISIBLE IF THE TYPE IS CLOUDINARY */}
          <Box className={classes.videoWrapper}>
            <video
              ref={cloudinaryRef}
              id="cloudinaryVideo"
              height={'100%'}
              className={classes.video}
              muted={mutedResult}
              style={{
                display:
                  liveVideo && liveVideo.type === 'cloudinary'
                    ? 'block'
                    : 'none',
                background:
                  'url(https://www.almexperts.com/Images/loading.gif) no-repeat center center',
                backgroundSize: '50px'
              }}
              onPlay={e => {
                // setTimeout to prevent pausing issue
                setTimeout(() => {
                  setTimeout(async function() {
                    try {
                      await dispatch(getServerTime(streamId)).then(data => {
                        //set the videoplayhead to that according the server
                        //console.log('reset the playhead ')
                        cloudinaryRef.current.currentTime = data
                      })
                    } catch (err) {
                      console.log(err)
                    }
                  }, 3000)
                  e.persist()
                  if (!videoControlled) {
                    dispatch(setVideoControlled('cloudinary', true))
                  } else {
                    setEventDetailsOpen(false)
                  }
                })
              }}
              onPlaying={e => {
                try {
                  //cloudinaryRef.buffer = cloudinaryRef.buffer + 1 || 1
                  //console.log(cloudinaryRef.buffer)
                  if (cloudinaryRef.current.currentTime === 0) {
                    //cloudinaryRef.buffer = 0
                    setTimeout(async function() {
                      await dispatch(getServerTime(streamId)).then(data => {
                        //set the videoplayhead to that according the server
                        //console.log('reset the playhead ')
                        //console.log(data)
                        cloudinaryRef.current.currentTime = data
                      })
                    }, 3000)
                  }
                } catch (err) {
                  console.log(err)
                }
              }}
              onError={(e, val) => {
                console.log(val)
                e.persist()
                console.log(
                  'cloudinary element video error: ',
                  e,
                  cloudinaryVideo.error
                )
                dispatch(removeStreamLocal(liveVideo.id))
                if (!currentItem && !donateMode) {
                  setEventDetailsOpen(true)
                }
              }}
              playsInline="playsinline"
              controls={false}
            />
            {/* THIS VIDEO ELEMENT IS HIDDEN IF THE TYPE IS CLOUDINARY */}
            <video
              ref={egliveRef}
              id="egliveVideo"
              className={classes.video}
              height={'100%'}
              muted={mutedResult}
              style={{
                display:
                  liveVideo && liveVideo.type === 'cloudinary'
                    ? 'none'
                    : 'block',
                background:
                  'url(https://www.almexperts.com/Images/loading.gif) no-repeat center center',
                backgroundSize: '50px'
              }}
              onPlay={e => {
                // setTimeout to prevent pausing issue
                setTimeout(() => {
                  e.persist()
                  if (!videoControlled) {
                    dispatch(setVideoControlled('egLive', true))
                  } else {
                    setEventDetailsOpen(false)
                  }
                })
              }}
              onError={(e, val) => {
                e.persist()
                console.log('live video element error: ', e, egliveVideo.error)
                dispatch(removeStreamLocal(liveVideo.id))
                if (!currentItem && !donateMode) {
                  setEventDetailsOpen(true)
                }
              }}
              playsInline="playsinline"
            />
          </Box>
        </Fragment>
      )}
    </div>
  )
}

export default withStyles(styles)(LiveVideo)



// WEBPACK FOOTER //
// ./src/components/LiveVideo/index.jsx